// ** React Imports
import { useState, useEffect } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid';
import {
    CardContent,
    Divider,
    FormControl,
    IconButton,
    TextField,
    Tooltip,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import { useToast } from '../../../components/ToastProvider'
import Swal from "sweetalert2";
import Button from '@mui/material/Button'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(45, 'days').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getData()
    }, [])

    const navigate = useNavigate();

    const getData = async () => {
        try {
            let url = apiUrl.apiUrl + '/acc/kalkulasi-wo/list'

            const response = await axios.get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                },
                headers: { Authorization: `Bearer ${token}` }
            })

            if (response.data.success) {
                setListData(response.data.data)
            } else {
                showToast(response.data.message, 'error')
            }
        } catch (err) {
            console.error(err)
        }
    }

    const ActionButtons = ({ row, onNavigate }: {
        row: any;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Cetak Work Order",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/production/work-order/pdf/' + row.id, '_blank')
            },
            {
                title: "Cetak List BOM",
                icon: "mdi:printer-settings",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/production/work-order/pdf-bom/' + row.id, '_blank')
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 180,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onNavigate={(id) => navigate('/acc/kalkulasi-wo/detail/' + id)}
                />
            ),
        },
    ];

    const convertComponent = [
        {
            key: 'gambar',
            renderCell: ({ row }: any) => {
                const url = row.data?.gambar;

                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>;
                }

                const openImage = () => {
                    Swal.fire({
                        title: 'Preview Gambar',
                        imageUrl: url,
                        imageWidth: 400,     // atur ukuran gambar
                        imageHeight: 'auto',
                        imageAlt: 'Preview',
                        showCloseButton: true,
                        showConfirmButton: false,
                        background: '#f9f9f9',
                    });
                };

                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "120px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                        onClick={openImage}
                    />
                );
            }
        }
    ];

    return (

        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='WORK ORDER' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData()}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <MsiDatagrid
                            array={listData}
                            actions={actionData}
                            convertRupiah={[
                                'biaya_quantifier', 'biaya_actual', 'hpp_quantity', 'hpp_actual',
                                'hpp_quantifer', 'bahan_baku', 'non_bahan_baku', 'total_margin'
                            ]}
                            hiddenColumns={['dokumen', 'tgl_aktif', 'tgl_selesai', 'is_aktif']}
                            customRender={convertComponent}
                        />
                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}
